import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-16 items-center justify-center bg-bg-main overflow-hidden" data-id="element-103">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[500px] rounded-full pointer-events-none opacity-40 blur-3xl" style={{
      background: 'radial-gradient(circle, rgba(37,99,235,0.15) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-104"></div>

      {/* BADGE */}
      <div className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[11px] sm:text-sm px-4 py-2 sm:px-6 sm:py-2.5 rounded-full mb-4 sm:mb-6 flex items-center gap-2 shadow-sm uppercase tracking-wide max-w-[95%]" data-id="element-105">
        <span className="w-2 h-2 rounded-full bg-badge-red animate-pulse-composited flex-shrink-0" data-id="element-106"></span>
        <span className="hidden sm:inline" data-id="element-107">
          🚨 INSEGNI EDUCAZIONE CIVICA E PASSI ANCORA ORE A PREPARARE ATTIVITÀ?
        </span>
        <span className="sm:hidden text-[10px] leading-tight" data-id="element-108">
          🚨 PASSI ANCORA ORE A PREPARARE EDUCAZIONE CIVICA?
        </span>
      </div>

      {/* HEADLINE */}
      <h1 className="relative font-black text-text-main max-w-4xl mb-3 sm:mb-5 tracking-tight text-[28px] leading-[1.1] sm:text-6xl md:text-7xl sm:leading-[1.05]" data-id="element-109">
        Tutto il tuo anno di{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary inline-block" data-id="element-110">
          EDUCAZIONE CIVICA
        </span>
        <span className="block mt-1.5 sm:mt-2" data-id="element-111">in 5 minuti.</span>
      </h1>

      {/* SUBHEADLINE */}
      <p className="relative text-text-sec text-base sm:text-2xl font-medium leading-relaxed mb-5 sm:mb-8 max-w-3xl mx-auto" data-id="element-112">
        Il sistema{' '}
        <span className="text-primary font-bold" data-id="element-113">"Apri e Insegna"</span> con
        lezioni, verifiche, dibattiti, compiti di realtà e progetti pronti per
        tutta la Scuola Secondaria.
      </p>

      {/* MICRO BENEFITS — compact inline row */}
      <div className="relative flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mb-4 sm:mb-6 text-text-main text-xs sm:text-base font-semibold max-w-2xl" data-id="element-114">
        <span className="flex items-center gap-1.5" data-id="element-115">
          <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-check-green flex-shrink-0" data-id="element-116" />
          Scuola Media e Superiore
        </span>
        <span className="flex items-center gap-1.5" data-id="element-117">
          <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-check-green flex-shrink-0" data-id="element-118" />
          1.000+ Docenti
        </span>
        <span className="flex items-center gap-1.5" data-id="element-119">
          <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-check-green flex-shrink-0" data-id="element-120" />
          Accesso Immediato
        </span>
        <span className="flex items-center gap-1.5" data-id="element-121">
          <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-check-green flex-shrink-0" data-id="element-122" />
          Nessuna Preparazione
        </span>
      </div>

      {/* MOCKUP */}
      <div className="relative w-full max-w-[300px] sm:max-w-[500px] md:max-w-[620px] mx-auto mb-4 sm:mb-8" data-id="element-123">
        <div className="absolute -inset-10 rounded-full pointer-events-none opacity-50 blur-2xl" style={{
        background: 'radial-gradient(circle, rgba(37,99,235,0.2) 0%, transparent 65%)'
      }} aria-hidden="true" data-id="element-124"></div>
        <img src="https://cdn.magicpatterns.com/uploads/sQwk4yuHAtCWLmBg76sCeX/ChatGPT_Image_2_jun_2026,_13_18_13-Photoroom.png" alt="Educazione Civica Pronta - Kit Completo" className="relative w-full h-auto object-contain drop-shadow-2xl hover:-translate-y-2 transition-transform duration-500" width={520} height={390} sizes="(max-width: 640px) 220px, (max-width: 768px) 420px, 520px" fetchPriority="high" loading="eager" decoding="async" data-id="element-125" />
      </div>

      {/* SOCIAL PROOF */}
      <div className="relative flex flex-col items-center gap-3 mb-4 sm:mb-8" data-id="element-126">
        <div className="flex items-center gap-2" data-id="element-127">
          <span className="text-secondary text-xl sm:text-2xl" data-id="element-128">⭐⭐⭐⭐⭐</span>
          <span className="text-text-main text-base sm:text-lg font-bold" data-id="element-129">
            4.9/5{' '}
            <span className="text-text-sec font-medium" data-id="element-130">(+500 recensioni)</span>
          </span>
        </div>
      </div>

      {/* CTA */}
      <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-16 py-5 sm:py-6 rounded-2xl hover:bg-cta-green-hover hover:scale-[1.02] transition-all inline-block mb-3 sm:mb-6 w-full sm:w-auto max-w-2xl text-white shadow-[0_10px_40px_rgba(16,185,129,0.4)] border border-white/20 tracking-tight" data-id="element-131">
        🚀 SÌ! VOGLIO IL KIT COMPLETO
      </a>

      {/* TRUST INDICATORS */}
      <div className="relative flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-text-sec text-sm font-medium" data-id="element-132">
        <span className="flex items-center gap-1.5" data-id="element-133">
          <span className="text-lg" data-id="element-134">⚡</span> Accesso Immediato
        </span>
        <span className="text-border-light" data-id="element-135">•</span>
        <span className="flex items-center gap-1.5" data-id="element-136">
          <span className="text-lg" data-id="element-137">🛡️</span> Garanzia 7 Giorni
        </span>
        <span className="text-border-light" data-id="element-138">•</span>
        <span className="flex items-center gap-1.5" data-id="element-139">
          <span className="text-lg" data-id="element-140">💳</span> Pagamento Unico
        </span>
      </div>
    </section>;
}